import {
  PRICE_POLICIES_GET_VERSIONS_BEGIN,
  PRICE_POLICIES_GET_VERSIONS_SUCCESS,
  PRICE_POLICIES_GET_VERSIONS_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case PRICE_POLICIES_GET_VERSIONS_BEGIN:
      return {
        ...state,
        stockDataPending: action.data.stockDataPending,
        stockData: action.data.stockData,
        factoryDiscount: action.data?.factoryCarLotDiscount?.factory_discount,
        carLotDiscount: action.data?.factoryCarLotDiscount?.car_lot_discount,
      }
    case PRICE_POLICIES_GET_VERSIONS_SUCCESS:
      return {
        ...state,
        stockDataPending: action.data.stockDataPending,
        stockData: action.data.stockData,
        factoryDiscount: action.data?.factoryCarLotDiscount?.factory_discount,
        carLotDiscount: action.data?.factoryCarLotDiscount?.car_lot_discount,
        stockDataError: false,
      }
    case PRICE_POLICIES_GET_VERSIONS_FAILURE:
      return {
        ...state,
        stockDataPending: action.data.stockDataPending,
        stockDataError: action.data.stockDataError
      }
    default:
      return state
  }
}
